import React from 'react';
import type { ElementRef, Ref, ReactNode } from 'react';

import { styled, theme } from '@backyard-ui/styles';
import type { StitchesCSS } from '@backyard-ui/styles';

import styles from './Skeleton.styles';
export interface SkeletonProps {
  /**
   * The CSS `width` property
   */
  width?: keyof typeof theme.sizes | string;

  /**
   * The CSS `height` property
   */
  height?: keyof typeof theme.sizes | string;

  /**
   * Enable/Disable animation
   */
  hasAnimation?: boolean;

  /**
   * The CSS `border-radius` property
   */
  isCircle?: boolean;

  /**
   * If true, render the children
   */
  isLoaded?: boolean;

  /**
   * Stitches `css` func
   */
  css?: StitchesCSS;

  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLDivElement>;

  /**
   * The children elements
   */
  children?: ReactNode;
}

const DEFAULT_TAG = 'div';

const SkeletonEl = styled(DEFAULT_TAG, styles);

const Skeleton = React.forwardRef<
  ElementRef<typeof DEFAULT_TAG>,
  SkeletonProps
>((props, ref) => {
  const {
    children,
    width = 'full',
    height = 'auto',
    css,
    isCircle = false,
    isLoaded = false,
    ...rest
  } = props;

  //@ts-ignore
  const getHeight = theme.sizes[height] || height;
  //@ts-ignore
  const getWidth = isCircle ? getHeight : theme.sizes[width] || width;

  if (isLoaded) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <SkeletonEl
      ref={ref}
      css={{
        $$width: getWidth,
        $$height: getHeight,
        ...css,
      }}
      isCircle={isCircle}
      {...rest}
    >
      {children}
    </SkeletonEl>
  );
});

Skeleton.displayName = 'Skeleton';

export default Skeleton;
